import React, { memo } from 'react';
import { createUseStyles, Modal, Textarea } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';
import { svgPositive } from './feedbackSvgs';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotFeedback');

const Feedback = memo(({ vote, value, onChange, onRequestClose, onClose, onConfirm }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();

    if (!vote) return null;
    return (
        <Modal
            className="dana-modal-feedback"
            isOpen={!!vote}
            width="480px"
            size="small"
            title={t('label_title_dana_chat_feedback')}
            onRequestClose={onRequestClose}
            onConfirm={onConfirm}
            onCancel={onClose}
            confirmText={t('label_send')}
            cancelText={t('action_cancel')}
        >
            <div className={classes.container}>
                <div className={classes.svg}>{svgPositive}</div>
            </div>
            <Textarea
                isFullWidth
                isResizable={false}
                placeholder={t('label_placeholder_dana_chat_feedback_positive')}
                value={value}
                onChange={onChange}
            />
        </Modal>
    );
});

export default Feedback;
